import { render, staticRenderFns } from "./AccountBoxHeader.vue?vue&type=template&id=82d58778"
import script from "./AccountBoxHeader.vue?vue&type=script&lang=js"
export * from "./AccountBoxHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82d58778')) {
      api.createRecord('82d58778', component.options)
    } else {
      api.reload('82d58778', component.options)
    }
    module.hot.accept("./AccountBoxHeader.vue?vue&type=template&id=82d58778", function () {
      api.rerender('82d58778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/accounts/AccountBoxHeader.vue"
export default component.exports